import { AdminListView } from "./AdminListView";
import { configurationItemAdapter } from "./configurationItemAdapter";

export function ConfigurationItemAdminPage() {
  return <AdminListView adapter={configurationItemAdapter} />;
}
